import React from 'react';

export default function TrashIcon () {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.41953 6.55078H5.41953H21.4195" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.41953 6.55078V4.55078C8.41953 4.02035 8.63024 3.51164 9.00531 3.13657C9.38038 2.76149 9.88909 2.55078 10.4195 2.55078H14.4195C14.95 2.55078 15.4587 2.76149 15.8337 3.13657C16.2088 3.51164 16.4195 4.02035 16.4195 4.55078V6.55078M19.4195 6.55078V20.5508C19.4195 21.0812 19.2088 21.5899 18.8337 21.965C18.4587 22.3401 17.95 22.5508 17.4195 22.5508H7.41953C6.88909 22.5508 6.38038 22.3401 6.00531 21.965C5.63024 21.5899 5.41953 21.0812 5.41953 20.5508V6.55078H19.4195Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
